
import React from 'react';
import CustomLandingPage from '@/components/landing/CustomLandingPage';
import { LandingProvider } from '@/context/LandingContext';
import { useLandingPage } from '@/hooks/useLandingPage';

const BusinessCustomLanding: React.FC = () => {
  const { settings, isLoading, businessName } = useLandingPage();

  return (
    <LandingProvider 
      settings={settings} 
      isLoading={isLoading} 
      businessName={businessName}
    >
      <CustomLandingPage />
    </LandingProvider>
  );
};

export default BusinessCustomLanding;
